import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'dropdown', 'frame', 'option']
  static values = { url: String }

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
    document.addEventListener('mousedown', this.boundClickOutside)
  }

  disconnect() {
    document.removeEventListener('mousedown', this.boundClickOutside)
  }

  open() {
    this.dropdownTarget.classList.remove('hidden')
    this.search()
  }

  close() {
    this.dropdownTarget.classList.add('hidden')
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  search() {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set('query', this.inputTarget.value.trim())
    this.frameTarget.src = url.toString()
  }

  pick(event) {
    event.preventDefault()
    this.choose(event.currentTarget)
  }

  keydown(event) {
    if (event.key === 'Escape') {
      this.close()
      this.inputTarget.blur()
    }
    if (event.key === 'Enter') {
      event.preventDefault()
      if (this.hasOptionTarget) this.choose(this.optionTarget)
    }
  }

  choose(option) {
    this.inputTarget.value = option.dataset.label
    this.close()
    this.inputTarget.blur()
    this.dispatch('picked', { detail: { phoneNumber: option.dataset.phoneNumber, countryCode: option.dataset.countryCode } })
  }
}
